<template>
  <div>
    <div class="table">
      <el-form :model="form" label-width="120px" :rules="rules" ref="ruleForm">
        <el-form-item label="简介内容" prop="title">
          <HtmlText ref="editHtml" :html="editData.content" />
        </el-form-item>

      </el-form>
      <div class="dialog-Btn">
        <el-button size="small" @click="closedialog">取消</el-button>
        <el-button size="small" type="primary" @click="updateData">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import HtmlText from "@/views/models/editHtml.vue"
import { addProgrammeCustomDetail } from "@/api/pageTemplate.js";

export default {
  name: 'content_edit',
  props: {
    closedialog: {
      type: Function,
      default: () => { }
    }
  },
  components: {
    HtmlText
  },
  watch: {

  },
  data () {
    return {
      form: {},
      saveData: {},
      editData: {},
    }
  },
  created () {
    this.$nextTick(() => {
      this.editData = JSON.parse(this.$store.state.pageTemplateData.customDetailList[0].content)
      this.saveData = this.$store.state.pageTemplateData.customDetailList[0]
    })
  },
  methods: {
    updateData () {
      this.editData.content = this.$refs.editHtml.getHtml()
      this.saveData.content = JSON.stringify(this.editData)
      addProgrammeCustomDetail(this.saveData).then(res => {
        if (res.data == 1) {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.closedialog()
          this.$store.commit('changeRefresh')
        } else {
          this.$message({
            message: res.msg,
            type: 'success'
          });
        }

      })
    },
  }
}

</script>
<style  lang="scss" scoped>
.dialog-Btn {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>